export default "__VITE_ASSET__CGPIroJ1__"